const doc = [({"da":({"js":({"admin":({"competitions":({"index":({"new_competition":"Ny konkurrence", "the_competition_was_deleted":"Konkurrencen blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;